import { render, staticRenderFns } from "./FormattingRuleSetup.vue?vue&type=template&id=f1feea4a&scoped=true&"
import script from "./FormattingRuleSetup.vue?vue&type=script&lang=ts&"
export * from "./FormattingRuleSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1feea4a",
  null
  
)

export default component.exports